<!--
Checkbox按钮

使用说明：

<CheckboxButton
:value="true/false"
@onChange="(isSelected)=>{}"
 />

-->

<template>
    <div class="checkbox-wrap" @click="toggleSelected">
        <Icon v-if="isSelected" class="icon-checkbox" :img="selectedImg" />
        <span v-else class="icon-checkbox icon-checkbox-empty"></span>
    </div>
</template>

<script>

const selectedImg = require('../../assets/icon-checkbox-selected.png')

export default {
  props: ['value'],
  data(){
    return {
        selectedImg,
        isSelected: this.value
    }
  },
  watch:{
      value: function(v){
          this.isSelected = v;
      }
  },
  methods: {
    toggleSelected(){
        this.isSelected = !this.isSelected;
        this.$emit('onChange', this.isSelected);
    },
    clearSelected(){
        this.isSelected = false;
        this.$emit('onChange', this.isSelected);
    }
  }
}
</script>

<style lang="less" scoped>

.checkbox-wrap{
    display: inline-block;
    vertical-align: middle;
}

.icon-checkbox{
    display: inline-block;
    width: 4vw;
    height: 4vw;
    border-radius: 50%;
    border: .13vw solid transparent;
}

.icon-checkbox-empty{
    border: .14vw solid #414141;
    background: #fff;
    
}

</style>





// WEBPACK FOOTER //
// src/components/kubaolottery/ModalCheckboxButton.vue